<template>
    <div class="animated fadeIn" v-if="satisfiedDependencies">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-user text-primary mr-2"></i>
                    Ficha de usuario
                </h4>
            </b-col>
        </b-row>

        <b-row class="pb-4">

            <b-tabs card class="w-100">

                <b-tab title="Ficha Usuario" active>
                    <b-form @submit.prevent="store" autocomplete="off">
                        <b-row class="pb-2">
                            <b-col sm="12" md="4">
                                <b-form-group>
                                    <label for="username"><strong>Nombre de Usuario *</strong></label>
                                    <b-input-group>
                                        <b-input-group-prepend>
                                            <b-input-group-text><i class="fa fa-user"></i></b-input-group-text>
                                        </b-input-group-prepend>
                                        <b-form-input
                                            type="text"
                                            id="username"
                                            placeholder="Introduzca nombre de usuario"
                                            v-model="user.username"
                                            autocomplete="off"
                                            :required="true">
                                            <i class="fa fa-user"></i>
                                        </b-form-input>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4">
                                <b-form-group>
                                    <label for="password"><strong>Contraseña *</strong></label>
                                    <b-input-group>
                                        <b-input-group-prepend>
                                            <b-input-group-text><i class="fa fa-asterisk"></i></b-input-group-text>
                                        </b-input-group-prepend>
                                        <b-form-input
                                            :type="visible ? 'text' : 'password'"
                                            id="password"
                                            placeholder="Introduzca contraseña"
                                            autocomplete="new-password"
                                            v-model="user.password"></b-form-input>
                                        <b-input-group-append @click="visible = !visible">
                                            <b-input-group-text class="bg-white border-left-0">
                                                <i class="fa fa-eye"></i>
                                            </b-input-group-text>
                                        </b-input-group-append>
                                        <div class="w-100" v-if="error">
                                            <small class="form-text">
                                                Mayúscula, minúscula, número y símbolo.
                                            </small>
                                        </div>

                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4">
                                <b-form-group>
                                    <label for="email"><strong>Email *</strong></label>
                                    <b-input-group>
                                        <b-input-group-prepend>
                                            <b-input-group-text>
                                                <i class="fa fa-envelope"></i>
                                            </b-input-group-text>
                                        </b-input-group-prepend>
                                        <b-form-input
                                            type="email"
                                            id="email"
                                            placeholder="Introduzca email"
                                            autocomplete="off"
                                            v-model="user.email"
                                            required>
                                            <i class="fa fa-email" required></i>
                                        </b-form-input>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12" md="6" lg="4">
                                <b-form-group
                                    label="<strong>Nombre *</strong>"
                                    label-for="firstname"
                                    :horizontal="false"
                                    class="w-100">
                                    <b-form-input
                                        id="firstname"
                                        type="text"
                                        placeholder="Nombre"
                                        v-model="user.firstname"
                                        autocomplete="off"></b-form-input>
                                </b-form-group>
                                <b-form-group
                                    label="<strong>Apellidos *</strong>"
                                    label-for="lastname"
                                    :horizontal="false"
                                    class="w-100">
                                    <b-form-input
                                        id="lastname"
                                        type="text"
                                        placeholder="Apellidos"
                                        v-model="user.lastname"
                                        autocomplete="off"></b-form-input>
                                </b-form-group>
                                <b-form-group
                                    label="<strong>Sexo</strong>"
                                    label-for="sex"
                                    :horizontal="false"
                                    class="w-100"
                                    v-if="userSexes">
                                    <multiselect
                                        name="sex"
                                        v-model="user.sex"
                                        :allow-empty="true"
                                        :options="userSexes.map(type => type.value)"
                                        :custom-label="opt => userSexes.find(x => x.value == opt).text"
                                        selectLabel="+"
                                        deselectLabel="-"
                                        placeholder="Seleccione opción"></multiselect>
                                </b-form-group>
                                <b-form-group
                                    label="<strong>Teléfono</strong>"
                                    label-for="phone"
                                    :horizontal="false"
                                    class="w-100">
                                    <b-form-input
                                        id="phone"
                                        type="text"
                                        placeholder="Fijo o móvil"
                                        autocomplete="off"
                                        v-model="user.phone"></b-form-input>
                                    <div v-if="!validatePhone() && user.phone">
                                        <small class="form-text text-danger">
                                            No válido
                                        </small>
                                    </div>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="6" lg="4">
                                <b-form-group
                                    label="<strong>Estado</strong>"
                                    label-for="status"
                                    :horizontal="false"
                                    class="w-100"
                                    v-if="userStates">
                                    <multiselect
                                        name="status"
                                        v-model="user.status"
                                        :allow-empty="true"
                                        :options="userStates.map(type => type.value)"
                                        :custom-label="opt => userStates.find(x => x.value == opt).text"
                                        selectLabel="+"
                                        deselectLabel="-"
                                        placeholder="Seleccione opción"></multiselect>
                                </b-form-group>
                                <b-form-group
                                    label="<strong>Roles</strong>"
                                    label-for="roles"
                                    :horizontal="false"
                                    class="w-100">
                                    <multiselect
                                        name="roles"
                                        v-model="user.roles"
                                        :options="roles"
                                        label="description"
                                        track-by="uuid"
                                        :multiple="true"
                                        :allowEmpty="true"
                                        placeholder="Seleccione"
                                        selectLabel="+"
                                        deselectLabel="-">
                                    </multiselect>
                                </b-form-group>
                                <b-form-group
                                    class="animated fadeIn"
                                    v-if="hasAdvisoryRoles && topLevelQueryCategories.length">
                                    <label for="specialty"><strong>Especialidad</strong></label>
                                    <multiselect
                                        id="specialty"
                                        v-model="user.specialtyId"
                                        :options="topLevelQueryCategories.map(type => type.uuid)"
                                        :multiple="false"
                                        :allowEmpty="true"
                                        :custom-label="opt => topLevelQueryCategories.find(x => x.uuid  === opt).name"
                                        placeholder="Seleccione opción"
                                        selectLabel="+"
                                        deselectLabel="-"></multiselect>
                                </b-form-group>
                                <b-form-group
                                    label="<strong>Delegación *</strong>"
                                    label-for="delegation"
                                    :horizontal="false"
                                    class="w-100">
                                    <multiselect
                                        name="delegation"
                                        v-model="user.delegationId"
                                        :options="headquarters.map(type => type.uuid)"
                                        :multiple="false"
                                        :allowEmpty="false"
                                        :custom-label="opt => headquarters.find(x => x.uuid  == opt).name"
                                        placeholder="Seleccione opción"
                                        selectLabel="+"
                                        deselectLabel="-"
                                        required></multiselect>
                                </b-form-group>
                                <b-form-group
                                    label="<strong>Departamento *</strong>"
                                    label-for="department"
                                    :horizontal="false"
                                    class="w-100 animated fadeIn"
                                    v-if="!!this.departments.departments && departments.departments.length">
                                    <multiselect
                                        name="department"
                                        v-model="user.departmentId"
                                        :options="departments.departments.map(type => type.uuid)"
                                        :multiple="false"
                                        :allowEmpty="true"
                                        :custom-label="opt => departments.departments.find(x => x.uuid == opt).code"
                                        placeholder="Seleccione opción"
                                        selectLabel="+"
                                        deselectLabel="-"
                                        required></multiselect>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="6" lg="4">
                                <b-form-group
                                    label="<strong>Sedes *</strong>"
                                    label-for="headquarters"
                                    :label-cols="3">
                                    <b-form-checkbox-group
                                        stacked
                                        id="headquarters"
                                        name="headquarters"
                                        v-model="user.headquarters">
                                        <template v-for="headquarter in headquarters">
                                            <b-form-checkbox :value="headquarter.uuid">
                                                {{ headquarter.name }}
                                            </b-form-checkbox>
                                        </template>
                                    </b-form-checkbox-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <div class="col float-left">
                                <button
                                    type="submit"
                                    class="btn btn-brand btn-primary btn-lg pull-right"
                                    :disabled="!generalValidate()"
                                    v-if="mixinCheckPermission('USER_EDIT')">
                                    Guardar
                                </button>
                            </div>
                        </b-row>
                    </b-form>
                </b-tab>


                <b-tab title="Permisos">
                    <permission-check-list
                        :allPermissions="permissions"
                        :initialPermissions="user.userPermissions"
                        :disabledPermissions="getUserRolesPermissions()"
                        @emit-permission-uuids="updateUserPermissions($event)">
                        <div class="w-100 d-flex justify-content-between align-items-center m-0 px-3">
                            <div>
                                <small>* Los permisos incluidos en los roles del usuario aparecerán como deshabilitados</small>
                            </div>
                            <div>
                                <button
                                    type="submit"
                                    class="btn btn-brand btn-primary btn-lg"
                                    v-if="mixinCheckPermission('USER_EDIT')">
                                    Guardar
                                </button>
                            </div>
                        </div>
                    </permission-check-list>
                </b-tab>

                <b-tab title="Actividad">

                    <user-activity-tab :user="user"></user-activity-tab>

                </b-tab>

            </b-tabs>
        </b-row>
    </div>
</template>

<script>

    import Multiselect from 'vue-multiselect';
    import UserActivityTab from './UserActivityTab';
    import form from '@/helpers/form';
    import {getRoles} from '@/api/role-api';
    import {getPermissions} from '@/api/permission-api';
    import {updateUser, updateUserPermissions} from '@/api/user-api';
    import {getUserStatesOptions, getUserSexesOptions} from '@/helpers/user-helper';
    import PermissionCheckList from '@/components/permissions/PermissionsCheckList';
    import {getQueryCategories} from '@/api/query-category-api';
    import {isAdvisoryRole} from '@/helpers/role-helper'

    export default {
        name: 'editUsers',
        components: {
            Multiselect,
            PermissionCheckList,
            UserActivityTab
        },
        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getUser();
            this.getGeneral("headquarters", "headquarters");
            this.getRoles();
            this.getPermissions();
            this.getQueryAnswerTypes();
        },
        data: function () {
            return {
                topmenu: [
                    {name: 'Volver', path: '/admin/user/list', brand: 'fa fa-arrow-left'},
                ],
                departments: [],
                headquarters: [],
                roles: [],
                permissions: null,
                queryCategories: [],
                user: {
                    uuid: 0,
                    status: 0,
                    username: null,
                    password: null,
                    email: null,
                    firstname: null,
                    lastname: null,
                    sex: 0,
                    phone: null,
                    roles: [],
                    departmentId: null,
                    delegationId: null,
                    headquarters: [],
                    permissions: [],
                    userPermissions: [],
                    specialtyId: null
                },
                visible: false,
                error: true,
            }
        },
        computed: {
            satisfiedDependencies() {
                return (
                    this.user.uuid
                    && this.headquarters.length
                    && this.roles.length
                    && !!this.permissions
                );
            },
            userStates() {
                return getUserStatesOptions();
            },
            userSexes() {
                return getUserSexesOptions();
            },
            topLevelQueryCategories() {
                return this.queryCategories.filter((category) => (category.parent === undefined));
            },
            hasAdvisoryRoles() {
                return !!this.user.roles.find((role) => (isAdvisoryRole(role.name) === true));
            }
        },
        methods: {
            async getUser() {
                try {
                    this.$_loadingMixin_showLoading();
                    const response = await axios.get('user/' + this.$route.params.uuid);
                    this.$_loadingMixin_hideLoading();

                    if (response.status == "200") {
                        this.user = Object.assign({}, this.user, response.data);
                        delete (this.user["password"]);
                        this.user.permissions = Object.keys(response.data.permissions).map((key) => {
                            return response.data.permissions[key];
                        });
                        this.user.delegationId = form.parser(response.data.delegation, 'uuid', 'string');
                        this.user.departmentId = form.parser(response.data.department, 'uuid', 'string');
                        this.user.headquarters = (response.data.headquarters === undefined) ? [] : response.data.headquarters.map(obj => obj.uuid);
                        this.user.specialtyId = (!!response.data.specialty) ? response.data.specialty.uuid : null;
                    }
                } catch (error) {
                    this.$_notificationMixin_error('Operación denegada', 'Algo salió mal');
                    return error;
                }
            },
            store() {
                this.$_loadingMixin_showLoading();

                Object.keys(this.user).forEach(k => (this.user[k] === "") && delete this.user[k]); // limpiamos propiedades vacías
                let properties = Object.assign({}, this.user);
                properties.roles = properties.roles.map((role) => (role.uuid));
                if (!this.hasAdvisoryRoles) {
                    properties.specialtyId = null;
                }

                updateUser(this.$route.params.uuid, properties)
                    .then((response) => {
                        this.$_loadingMixin_hideLoading();
                        this.$_notificationMixin_success('Operación Completada', 'Realizado con éxito');
                        this.$router.push({path: '/admin/user/list'});
                    })
                    .catch((error) => {
                        this.$_loadingMixin_hideLoading();
                        this.$_notificationMixin_error('Operación denegada', 'Algo salió mal');
                    });
            },
            async getGeneral(url, varName) {
                try {
                    this.$_loadingMixin_showLoading();
                    const response = await axios.get(url);
                    if (response.status == "200") {
                        this[varName] = response.data;
                    }
                } catch (error) {
                    this.showErrorMsg()
                } finally {
                    this.$_loadingMixin_hideLoading();
                }
            },
            async getRoles() {
                this.$_loadingMixin_showLoading();
                await getRoles()
                    .then((roles) => {
                        this.roles = roles;
                    });
                this.$_loadingMixin_hideLoading();
            },
            async getPermissions() {
                this.$_loadingMixin_showLoading();
                await getPermissions()
                    .then((permissions) => {
                        this.permissions = permissions;
                    });
                this.$_loadingMixin_hideLoading();
            },
            async getQueryAnswerTypes() {
                this.$_loadingMixin_showLoading();
                await getQueryCategories()
                    .then((queryCategories) => {
                        this.queryCategories = queryCategories;
                    });
                this.$_loadingMixin_hideLoading();
            },
            getUserRolesPermissions() {
                return this.user.permissions.filter((permission) => {
                    return !this.user.userPermissions.find((userPermission) => (userPermission.uuid === permission.uuid));
                });
            },
            async updateUserPermissions(permissionUuids) {
                this.$_loadingMixin_showLoading();
                await updateUserPermissions(this.$route.params.uuid, permissionUuids)
                    .then((response) => {
                        this.$_notificationMixin_success('Operación Completada', 'Realizado con éxito');
                    })
                    .catch((error) => {
                        this.$_notificationMixin_error('Operación denegada', 'Algo salió mal');
                    });
                this.$_loadingMixin_hideLoading();
            },
            checkPassword() {
                let re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
                return re.test(this.user.password);
            },
            validatePhone() {
                return form.phone(this.user.phone)
            },
            generalValidate() {
                if (!this.user.username || !this.user.email || !this.user.delegationId || !this.user.departmentId) {
                    return false;
                } else if (this.user.phone && !this.validatePhone(this.user.phone)) {
                    return false;
                } else if (this.user.password && !this.checkPassword()) {
                    return false;
                } else {
                    return true;
                }
            }
        },
        watch: {
            'user.password': function () {
                this.error = !this.checkPassword();
            },
            'departments.departments': function () {
                if (!this.departments.departments.find(d => d.uuid === this.user.departmentId)) {
                    this.user.departmentId = null;
                }
            },
            'user.delegationId': {
                handler(value) {
                    if (!!this.user.delegationId) {
                        this.getGeneral("headquarter/" + this.user.delegationId, "departments")
                    }
                },
                deep: true
            }
        }
    }
</script>